import {
    VIEW_CANDIDATELIST_REQUEST,
    VIEW_CANDIDATELIST_SUCCESS,
    VIEW_CANDIDATELIST_FAIL
  
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "DASHBOARDCONTENT",
    result: [],
    response: {},
    msg: "",
    error: "",
  };
  
  const CandidatePageReducer = (state = initialState, action) => {
    switch (action.type) {
  
      case VIEW_CANDIDATELIST_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case VIEW_CANDIDATELIST_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          //   result: state.result.map((item) =>
          // item.candidateId === action.result.data.candidateId ? action.result.data : item
          //   ),
          response: action.result.msg,
          singledata: [],
          loading: action.payload,
  
          msg: action.msg,
        };
      case VIEW_CANDIDATELIST_FAIL:
        return {
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default CandidatePageReducer;
  